import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LoyaltyFeedListComponent } from './loyalty-feed/loyalty-feed-list/loyalty-feed-list.component';
import { LoyaltyFeedItemComponent } from './loyalty-feed/loyalty-feed-item/loyalty-feed-item.component';
import { LoyaltyFeedVouchersComponent } from './loyalty-feed/loyalty-feed-item/loyalty-feed-items/loyalty-feed-voucher/loyalty-feed-vouchers.component';
import { LoyaltyFeedGamesComponent } from './loyalty-feed/loyalty-feed-item/loyalty-feed-items/loyalty-feed-games/loyalty-feed-games.component';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { CountdownV2Component } from '@fgb/portal-component-library/src/lib/shared/countdown-v2';

import { GamesModule } from '@fgb/portal-component-library/src/lib/games';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [LoyaltyFeedListComponent, LoyaltyFeedItemComponent, LoyaltyFeedVouchersComponent, LoyaltyFeedGamesComponent],
  imports: [
    CommonModule,
    ErrorsModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    FGBSharedModule,
    RouterModule,
    PipesModule,
    LoadingModule,
    CountdownV2Component,
    GamesModule,
    NgbModule,
  ],
  exports: [LoyaltyFeedListComponent, LoyaltyFeedItemComponent, LoyaltyFeedVouchersComponent],
})
export class FeedModule {}
